import React, { useEffect, useState } from 'react';
import measureOfAmericaIcon from '../../assets/icons/measure_of_america.png';
import { useMap, useMapEvent } from 'react-leaflet';
import L from 'leaflet';
import { onSetActivePointStatus, onSetActiveGeography, useGlobalActiveGeography, useGlobalActivePage /*onSetCachedActiveIndicators,  onSetCachedSelectedIds, useGlobalCachedActiveIndicators, useGlobalCachedSelectedIds, onSetActiveIndicator, onSetBivariateIndicator*/ } from '../../data/StatusStore';
import { useData } from '../../data/DataContext';

interface MapClearPointsControlProps {
  onlyLogo:boolean;
}

const MapClearPointsControl: React.FC<MapClearPointsControlProps> = (onlyLogo) => {
  const map = useMap();
  const {
      geoJsonDataPUMA, geoJsonDataTract, 
      geoJsonDataNTA, geoJsonDataBoro,
      isLoadingTopology, error, dataPoint, 
      setDataPoint, pointDataList, pointModules
  } = useData();
  const activeGeography = useGlobalActiveGeography();
  const activePage = useGlobalActivePage();
  //const cachedActiveIndicators = useGlobalCachedActiveIndicators();
  //const cachedSelectedIds = useGlobalCachedSelectedIds();
  const [selectedValue, setSelectedValue] = useState<string>(activeGeography);
  const [activePoints, setActivePoints] = useState<boolean>(false);

  useEffect(() => {
    // Create a Leaflet Control to position the radio buttons on the map
    const controlContainer = L.DomUtil.create('div', 'leaflet-control leaflet-bar');
    const customControl = new L.Control({ position: 'bottomleft' }); // You can adjust the position

    customControl.onAdd = function() {
      L.DomEvent.disableClickPropagation(controlContainer);
      return controlContainer;
    };

    customControl.addTo(map);

    return () => {
      customControl.remove();
    };
  }, [map]);

  useEffect(() => {
    console.log("D041725 dataPoint", dataPoint);
    const hasActivePoints = Object.keys(dataPoint || {}).some(
      (key) => dataPoint[key]?.active === true
    );
    console.log("D041725 hasActivePoints", hasActivePoints);
    setActivePoints(hasActivePoints);
  }, [dataPoint]);

  useMapEvent('click', () => {
    // Optional: Respond to map clicks or other events
  });

  const clearDataPointActiveStatus = () => {
    console.log("A041025 dataPoint", dataPoint);
    if (dataPoint) {
      const updatedDataPoint = { ...dataPoint };
      Object.keys(updatedDataPoint).forEach((key) => {
        if (updatedDataPoint[key] && typeof updatedDataPoint[key] === 'object') {
          console.log("A041025 updatedDataPoint[key]", updatedDataPoint[key]);
          updatedDataPoint[key].active = false;
          if (updatedDataPoint[key].item){
            updatedDataPoint[key].item.active = false;
          }
        }
      });
      console.log("A041025 updatedDataPoint", updatedDataPoint);
      setDataPoint(updatedDataPoint);
      onSetActivePointStatus('');
      /*setTimeout(() => {
        setDataPoint(updatedDataPoint);
      }, 500);*/
    }
  };

  return (
    <div className="leaflet-control-container">
      <div className="leaflet-bottom leaflet-left">
        {activePoints && (activePage === 'explorer')
        ?<div className="leaflet-control leaflet-control-custom"
          id='mapResetZoom'
          style={{
            paddingBottom: "3px",
            paddingTop: "3px",
            paddingRight: "10px",
            paddingLeft: "10px",
            cursor: "pointer",
          }}
          onClick={clearDataPointActiveStatus}
        >
            clear points
        </div>
        : <div className="leaflet-control"
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingLeft: "0px",
            paddingBottom: "0px",
            marginLeft: "0px",
            marginBottom: "0px",
            cursor: "pointer",
            backgroundColor: 'none',//"#000",
            //opacity: 0.5,
            //backgroundColor: "unset",
            //border: "none",
          }}>
          <img
            src={measureOfAmericaIcon}
            alt="Measure of America"
            style={{ width: "auto", height: "60px" }}
          />
        </div>}
      </div>
    </div>
  );
};

export default MapClearPointsControl;
